import clsx from 'clsx';

export default function Spinner({ full = false, label, className }) {
  const spinner = (
    <div className="flex flex-col items-center gap-3">
      <div className="h-8 w-8 rounded-full border-2 border-brand-500/25 border-t-brand-500 animate-spin" />
      {label && <p className="text-xs font-medium text-surface-500">{label}</p>}
    </div>
  );

  if (full) {
    return (
      <div className={clsx('min-h-screen flex items-center justify-center bg-surface-50', className)}>
        <div className="absolute inset-0 bg-dots-light opacity-30 pointer-events-none" />
        <div className="relative">{spinner}</div>
      </div>
    );
  }

  return (
    <div className={clsx('flex items-center justify-center py-12', className)}>
      {spinner}
    </div>
  );
}
